import { DialogContent, Grid, Box } from '@mui/material';
import { useState } from 'react';
import { MdDeleteForever } from 'react-icons/md';
import { WsButton, WsColors, WsTypography, WsTypoVariants } from 'wisestep-base';

interface ConfirmationDialogProps {
  confirm: () => void;
  close: () => void;
  text: string;
  title: string;
}
const ConfirmationDailog = ({ confirm, close, text }: ConfirmationDialogProps) => {
  const [disable, setDisable] = useState(false);
  return (
    <Box alignItems="center" borderRadius={2} display="flex" my={2}>
      <DialogContent>
        <Grid container spacing={2}>
          <Grid item xs={12} justifyContent="center" display="flex">
            <MdDeleteForever color={WsColors.TheBlues500} size={30} />
          </Grid>
          <Grid item xs={12} justifyContent="center" display="flex">
            <WsTypography variant={WsTypoVariants.TITLE}>{text}</WsTypography>
          </Grid>
          <Grid item xs={12} display="flex" justifyContent="end" container gap={1} mt={2}>
            <WsButton onClick={() => close()} variant="outlined">
              Cancel
            </WsButton>
            <WsButton
              disabled={disable}
              onClick={() => {
                confirm();
                setDisable(true);
              }}
            >
              Confirm
            </WsButton>
          </Grid>
        </Grid>
      </DialogContent>
    </Box>
  );
};
export default ConfirmationDailog;
